import BaseChange from "./BaseChange"

export default class InitialState extends BaseChange {
  constructor(messageString) {
    super()
    this.type = "initial"
    this.setMessage({ message: messageString })
  }
}
